import React from "react";
import styled from "@emotion/styled/macro";

import infoIconMet from "../res/i_info_metsnew.png";
import infoIcon from "../res/i_info.png";
import shareIcon from "../res/i_share.svg";
import IconButton from "./IconButton";
import IconButtonNew from "./IconButtonNew";

import PlayFab from "../Playfab/PlayFab";

import MainIndex from "../index";

const Footer = styled("footer")`
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707381;
  font-weight: 500;
`;

interface IProps {
  mainComponent: React.ReactNode;
  showEventInfo: () => void;
}

export default function BobbleFooter({ mainComponent, showEventInfo }: IProps) {
  const navigator: any = window.navigator;
  const { protocol, host } = window.location;
  const shareUrl = `${protocol}//${host}` + "/?bid=" + PlayFab.GetCurrentBobble();

  //console.log(shareUrl);
if(MainIndex.GetBobbleID() === "M0") {
  return (
    <Footer
      onMouseDown={e => e.stopPropagation()}
      onTouchStart={e => e.stopPropagation()}
    >
      <IconButtonNew
        icon={infoIconMet}
        onClick={e => {
          //showEventInfo();
          window.open("https://www.mlb.com/mets/video/mr-met-through-the-years?t=t121-default-vtp");
        }}
      />
      {mainComponent}
      <IconButton
        style={{
          visibility: navigator.share ? "visible" : "hidden"
        }}
        icon={shareIcon}
        onClick={e => {
          if (!navigator.share) {
            return;
          }
          navigator.share({
            title: "Digital Bobblehead Doll at New York Mets",
            //text: "I just got this digital bobblehead from the Tampa Bay Rays ",
            url: shareUrl
          });
        }}
      />
    </Footer>
  );
} else {
    return (
      <Footer
        onMouseDown={e => e.stopPropagation()}
        onTouchStart={e => e.stopPropagation()}
      >
        <IconButton
          icon={infoIcon}
          onClick={e => {
            //showEventInfo();
            window.open("https://www.mlb.com/video/austin-meadows-homers-1-on-a-fly-ball-to-left-center-field");
          }}
        />
        {mainComponent}
        <IconButton
          style={{
            visibility: navigator.share ? "visible" : "hidden"
          }}
          icon={shareIcon}
          onClick={e => {
            if (!navigator.share) {
              return;
            }
            navigator.share({
              title: "Digital Bobblehead Doll at Tampa Bay Rays ",
              //text: "I just got this digital bobblehead from the Tampa Bay Rays ",
              url: shareUrl
            });
          }}
        />
      </Footer>
    );
  }
}
